import { releaseItem } from './releaseItem';

export function koukoku() {
  const koukoku = document.querySelector('.js-koukoku');
  const url = 'https://secure02.red.shared-server.net/www.o-tec.co.jp/cron_marge/koukoku.php';

  const dataSet = (year) => {
    let param02 = {
      initial: false,
      year: year
    }

    fetch(url, {
      method : "POST",
      headers: {
        'Content-Type': 'application/json' // JSON形式のデータのヘッダー
      },
      body: JSON.stringify(param02)
    })
    .then((response) => {
      return response.json()　//ここでBodyからJSONを返す
    })
    .then((result02) => {
      const post_item = document.querySelectorAll('.js-koukoku_list li');
      post_item.forEach(item => {
        item.remove();
      });

      const koukokuList = document.querySelector('.js-koukoku_list');
      result02.dataList.forEach(data => {
        let dataItem = releaseItem(data);
        koukokuList.appendChild(dataItem);
      });
    })
  }

  if (koukoku) {
    //初期状態のdataを取ってくる
    let param01 = {
      initial: true,
      year: 0
    }
    fetch(url, {
      method : "POST",
      headers: {
        'Content-Type': 'application/json' // JSON形式のデータのヘッダー
      },
      body: JSON.stringify(param01)
    })
    .then((response) => {
      return response.json()　//ここでBodyからJSONを返す
    })
    .then((result) => {
      if(result.res) {
        const yearPanel = koukoku.querySelector('.js-koukoku_yaer--panel');
        let panel_item = document.createElement('span');
        panel_item.classList.add('js-select02--select');
        panel_item.textContent = result.yearList[0] + '年';
        yearPanel.appendChild(panel_item);

        const yearOption = koukoku.querySelector('.js-koukoku_yaer--tab');
      
        for (let index = 0; index < result.yearList.length; index++) {
          const year = result.yearList[index];
          let option_item = document.createElement('span');
          option_item.classList.add('c-selectType01_optionItem', 'js-select02--option', 'js-koukoku_yaer--option');
          if(index === 0) {
            option_item.classList.add('is-active');
          }
          option_item.dataset.value = year + '年';
          option_item.textContent = year + '年';
          yearOption.appendChild(option_item);
        }
      }

      const koukokuList = document.querySelector('.js-koukoku_list');
      result.dataList.forEach(data => {
        let dataItem = releaseItem(data);
        koukokuList.appendChild(dataItem);
      });
    })
    .then(() => {
      const options = document.querySelectorAll('.js-koukoku_yaer--option');
      options.forEach(option => {
        option.addEventListener('click', function() {
          let year_value = this.dataset.value.substr( 0, 4 );
          dataSet(year_value);
        })
      });
    })
    .catch((e) => {
      console.log(e)  //エラーをキャッチし表示     
    })
  }
}